import * as React from 'react';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  IsAllowed,
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { FeedbackForm } from 'cb-model';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const FeedbackFormSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'status', operator: 'eq', value: 'ACTIVE' },
        { fieldId: 'title', operator: 'ct', value: '' },
      ],
    },
  });
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(FeedbackForm, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(FeedbackForm, queryOptions);
  return (
    <>
      <PageTitle verb="Search" entity={FeedbackForm} />
      <Section>
        <IsAllowed entity={FeedbackForm} action="create">
          <Link to="/admin/feedback-form/create">
            <Button size="sm" variant="primary">
              Create a new Feedback Form
            </Button>
          </Link>
          <div className="mb20px" />
        </IsAllowed>
        <PaginatorAndListSettings
          entity={FeedbackForm}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
